<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="copy"><a id="page_4"><em><b>OLD GUY: SUPERHERO</b>, The Complete Collection</em></a></p><a id="page_4">
<p class="copy">Copyright © 2019 by William Trowbridge</p>
<p class="copy">All Rights Reserved</p>
<p class="copy1">No part of this book may be used or reproduced in any manner whatsoever without the prior written permission of both the publisher and the copyright owner.</p>
<p class="copy1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyh1">Names: Trowbridge, William, 1941– author. | Mayer, Tim (Artist), artist.</p>
<p class="copyh">Title: Oldguy: superhero : the complete collection poems by William Trowbridge ; art by Tim Mayer.</p>
<p class="copyh">Description: First edition. | Pasadena, CA : Red Hen Press, [2019]</p>
<p class="copyh">Identifiers: LCCN 2019024198 (print) | LCCN 2019024199 (ebook) | ISBN 9781888996425 (trade paperback) | ISBN 9781597098427 (ebook)</p>
<p class="copyh">Subjects: LCSH: Superheroes—Poetry. | Older people—Poetry.</p>
<p class="copyh">Classification: LCC PS3570.R66 O43 2019 (print) | LCC PS3570.R66 (ebook) | DDC 811/.54—dc23</p>
</a><p class="copyh"><a id="page_4">LC record available at </a><a href="https://lccn.loc.gov/2019024l98" target="_blank">https://lccn.loc.gov/2019024198</a></p>
<p class="copyh">LC ebook record available at <a href="https://lccn.loc.gov/2019024l99" target="_blank">https://lccn.loc.gov/2019024199</a></p>
<p class="copy1">The National Endowment for the Arts, the Los Angeles County Arts Commission, the Ahmanson Foundation, the Dwight Stuart Youth Fund, the Max Factor Family Foundation, the Pasadena Tournament of Roses Foundation, the Pasadena Arts &amp; Culture Commission and the City of Pasadena Cultural Affairs Division, the City of Los Angeles Department of Cultural Affairs, the Audrey &amp; Sydney Irmas Charitable Foundation, the Kinder Morgan Foundation, the Meta &amp; George Rosenberg Foundation, the Allergan Foundation, the Riordan Foundation, Amazon Literary Partnership, and the Mara W. Breech Foundation partially support Red Hen Press.</p>
<p class="copy1"><img alt="image" src="images/cp.jpg"/></p>
<p class="copy1">First Edition</p>
<p class="copy">Published by Red Hen Press</p>
<p class="copy"><a href="http://www.redhen.org" target="_blank">www.redhen.org</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?6672144e